﻿import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';

export type ReactStateSetter<T> = React.Dispatch<React.SetStateAction<T>>;

export interface UnknownObject extends Record<string, unknown> {}

export interface TopQuestionsCategories {
    questions: Question[];
    tags: Tag[];
}

export interface Question {
    kbEntryId: string;
    questionId: number;
    text: string;
    isFormAnswer: boolean;
}

export interface Tag {
    id: string;
    tenantId: string;
    text: string;
    excludeFrom: ExcludeType;
    excludeTagFrom: ExcludeType;
    featuredImageUrl: string | null;
    featured: boolean | null;
    ordinal: number | null;
}

export enum ExcludeType {
    None,
    FromFAQPages
}

export interface ArticleListItemModel {
    id: string;
    title: string;
    slug: string;
    tags: string[] | null;
}

export interface ArticleViewModel {
    versionId: string;
    articleId: string;
    title: string;
    tags: string[];
    content: string;
}

export interface CategorisedQuestionsAndArticles {
    questions: Question[];
    tag: Tag;
    articles: ArticleListItemModel[];
}

export interface Page {
    kbEntryId: string;
    question: string;
    answer: Answer;
    followUps: FollowUps[];
    video: Video | null;
    isForm: boolean;
    formName: string | null;
    tags: Tag[];
    qnaEntityId: number;
}

export interface Answer {
    kbEntryId: string;
    questionId: number;
    questionText: string;
    text: string;
    plainText: string;
}

export interface FollowUps {
    kbEntryId: string;
    questionId: number;
    text: string;
    isFormAnswer: boolean;
}

export interface Video {
    url: string;
    type: VideoType;
}

export enum VideoType {
    YouTube,
    Facebook
}

export interface RelatedQuestionsAndArticles {
    questions: Question[];
    articles: ArticleListItemModel[];
}

export enum QuestionOrArticleType {
    Question,
    Article
}

export interface QuestionOrArticle {
    type: QuestionOrArticleType;
    text: string;
    url: string;
}

export enum ArticleMetricType {
    View,
    FeedbackGood,
    FeedbackBad
}

export enum FeedbackType {
    Bad = 0,
    Good = 1
}

export interface MSALInfo {
    instance: IPublicClientApplication;
    accounts: AccountInfo[];
}
